const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#F8FAFC',
    minHeight: '100%',
    width: '100%',
    padding: '40px 24px',
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  body: {
    maxWidth: '1000px',
    margin: '0 auto',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  header: {
    marginBottom: '8px',
  },
  title: {
    fontSize: '28px',
    fontWeight: 700,
    color: '#0F172A',
    letterSpacing: '-0.02em',
  },
  subtitle: {
    fontSize: '15px',
    color: '#64748B',
    marginTop: '4px',
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '32px',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
    border: '1px solid #F1F5F9',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#1E293B',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  stepperPaper: {
    padding: '24px',
    borderRadius: '16px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #F1F5F9',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
  stepper: {
    padding: 0,
    backgroundColor: 'transparent',
  },
  backLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    color: '#64748B',
    fontSize: '14px',
    fontWeight: 500,
    textDecoration: 'none',
    cursor: 'pointer',
    marginBottom: '16px',
    transition: 'color 0.2s',
    '&:hover': {
      color: '#0F172A',
    },
  },
  settingsToggle: {
    padding: '16px 24px',
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #F1F5F9',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: 'all 0.2s',
    '&:hover': {
      borderColor: '#E2E8F0',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    },
  },
  settingsContent: {
    marginTop: '16px',
    padding: '20px',
    backgroundColor: '#F8FAFC',
    borderRadius: '12px',
    border: '1px solid #E2E8F0',
  },
  primaryButton: {
    height: '48px',
    padding: '0 24px',
    fontSize: '15px',
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: '10px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    },
  },
  secondaryButton: {
    height: '48px',
    padding: '0 24px',
    fontSize: '15px',
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: '10px',
    border: '1px solid #E2E8F0',
    color: '#475569',
    '&:hover': {
      backgroundColor: '#F1F5F9',
      borderColor: '#CBD5E1',
    },
  },
  linkCard: {
    padding: '20px',
    backgroundColor: '#F8FAFC',
    borderRadius: '16px',
    border: '1px solid #E2E8F0',
    textAlign: 'left',
    marginTop: '16px',
    width: '100%',
  },
  linkLabel: {
    fontSize: '12px',
    fontWeight: 700,
    color: '#64748B',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: '12px',
    display: 'block',
  },
  linkContent: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    border: '1px solid #E2E8F0',
    padding: '4px 4px 4px 16px',
    gap: '8px',
  },
  linkUrl: {
    fontSize: '14px',
    color: '#1E293B',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  linkActions: {
    display: 'flex',
    gap: '4px',
  },
  actionIconBtn: {
    padding: '8px',
    color: '#64748B',
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: '#F1F5F9',
      color: '#3B82F6',
    },
  },
  copySuccess: {
    color: '#10B981 !important',
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '40px',
  },
})

export default styles
